/**
 * Created by yniran on 26/01/15.
 */

define(function (require) {
    "use strict";

    var _ = require("underscore"),
        logger = require("logger").getLogger("LEConnection"),
        Modernizr = require("modernizr"),

        AUDIO_SUPPORT_TYPES = {   //Modernizr's html5-spec answers for type support
            "probably": 100,
            "maybe": 0
        },
        AUDIO_TYPES = {
            "mp3": 4,
            "ogg": 3,
            "wav": 2,
            "m4a": 1
        },
        _loadedFiles = {},
        _hasAudio, _preferredTypeExt,
        isPhantomJS = !!navigator.userAgent.match(/PhantomJS/i);

    function playSoundFile(options) {//options.fileName (without extension), options.container

        logger.debug("received request to play sound with name: ", "soundFileHelper.playSoundFile", options.fileName);
        var fileInfo = _loadedFiles[options.fileName];

        if (!fileInfo) {
            fileInfo = _loadFile(options);
        }

        if (fileInfo) {
            _playSoundFromFile(fileInfo);
        }
        else {
            logger.error("failed to load sound for file: ", "soundFileHelper.playSoundFile", options.fileName);
            logger.graph({name:"connection:SoundFileHelper:playSoundFile:failLoadSound"});

        }
    }

    function _playSoundFromFile(fileInfo) {

        var element = fileInfo.element;

        logger.debug("about to play sound for file: " + fileInfo.fileName, "soundFileHelper._playSoundFromFile");

        if (element) {
            try {
                if (_hasAudio) {
                    element.play();
                }
                else {
                    element.controls.play();
                }
            }
            catch (ex) {
                logger.error("failed to play sound!", "soundFileHelper._playSoundFromFile", ex);
                logger.graph({name:"connection:SoundFileHelper:_playSoundFromFile:failPlay"});
            }
        }
    }

    function _loadFile(options) {

        var fileNameWithExt = options.fileName + _preferredTypeExt,
            soundElement;

        if (!isPhantomJS) {
            if (_hasAudio) {
                soundElement = new Audio();
                soundElement.src = fileNameWithExt;
                soundElement.preload = "auto";
                soundElement.volume = 1;
                soundElement.name = options.fileName;
            }
            else {
                soundElement = document.createElement("embed");
                soundElement.src = fileNameWithExt;
                soundElement.name = options.fileName;
                soundElement.hidden = true;
                soundElement.autostart = false;
                soundElement.loop = false;
            }
        }

        options.container.append(soundElement);

        var info = _loadedFiles[options.fileName] = {
            fileName: options.fileName,
            element: soundElement
        };

        return info;
    }

    function _getPreferredAudioTypeExtension(audioSupport) {

        var support = [
            {ext: ".mp3", val: (AUDIO_TYPES.mp3 + (AUDIO_SUPPORT_TYPES[audioSupport.mp3] || 0))},
            {ext: ".ogg", val: (AUDIO_TYPES.ogg + (AUDIO_SUPPORT_TYPES[audioSupport.ogg] || 0))},
            {ext: ".wav", val: (AUDIO_TYPES.wav + (AUDIO_SUPPORT_TYPES[audioSupport.wav] || 0))},
            {ext: ".m4a", val: (AUDIO_TYPES.m4a + (AUDIO_SUPPORT_TYPES[audioSupport.m4a] || 0))}
        ];

        var sorted = _.sortBy(support, "val"); //sort so the highest value type is last

        return _.last(sorted).ext;
    }

    function _init() {
        _hasAudio = Modernizr.audio;

        if (_hasAudio) {
            _preferredTypeExt = _getPreferredAudioTypeExtension(_hasAudio);
        }
        else {
            _preferredTypeExt = ".mp3";
        }
    }

    _init();

    return {
        playSoundFile: playSoundFile
    };
});
